import ScrollReveal from '@/components/base/ScrollReveal';

export default function TermsPage() {
  return (
    <main className="min-h-screen bg-background-50 pt-24 pb-16">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <ScrollReveal>
          <h1 className="text-3xl md:text-4xl font-heading font-bold text-primary-500 mb-2">
            Terms of Use
          </h1>
          <p className="text-sm text-foreground-500 mb-8">
            Last updated: July 5, 2026
          </p>
        </ScrollReveal>

        <div className="prose prose-sm max-w-none text-foreground-700 space-y-6">
          <section>
            <h2 className="text-xl font-heading font-semibold text-primary-500 mb-3">
              1. Acceptance of Terms
            </h2>
            <p>
              By accessing and using the Joviaa website (joviaa.in), you accept and agree to be bound by these Terms of Use. If you do not agree, please do not use our website.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-primary-500 mb-3">
              2. Products &amp; Descriptions
            </h2>
            <p>
              Joviaa sells high-quality imitation jewellery under HSN 7117. All products are crafted from premium 316L stainless steel with PVD gold-tone plating. They are not solid gold and are priced and marketed accordingly. We strive to display product colours and images accurately, but variations may occur due to screen settings. All product descriptions, specifications, and prices are subject to change without notice.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-primary-500 mb-3">
              3. Orders &amp; Payment
            </h2>
            <p>
              By placing an order, you confirm that all information provided is accurate. We reserve the right to refuse or cancel any order at our discretion. Prices are listed in Indian Rupees (INR) and are inclusive of applicable GST and other taxes unless stated otherwise. Payment is due at the time of order placement via UPI, cards, net banking, or other supported methods. We do not accept cash on delivery (COD).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-primary-500 mb-3">
              4. Shipping &amp; Delivery
            </h2>
            <p>
              We ship across India via trusted courier partners. Estimated delivery times are provided during checkout and may vary by location. Joviaa is not responsible for delays caused by third-party courier services, customs, or events beyond our control. Risk of loss passes to you upon delivery of the product to the carrier. Shipping is free on orders above ₹1,499.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-primary-500 mb-3">
              5. Returns, Exchanges &amp; Refunds
            </h2>
            <p>
              We accept returns and exchanges within 7 days of delivery for unused, unworn products in their original packaging with all tags intact. To initiate a return or exchange, contact us at hello@joviaa.in or via WhatsApp at +91 96865 43847. Refunds will be processed to the original payment method within 7-10 business days after we receive and inspect the returned product. Items showing signs of wear, damage, or missing packaging are not eligible. Custom or personalised items are final sale and not eligible for return or exchange.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-primary-500 mb-3">
              6. Product Care &amp; Durability
            </h2>
            <p>
              Our imitation jewellery is designed for extended daily wear. However, longevity depends on proper care. Avoid prolonged exposure to harsh chemicals, perfumes, and chlorine. Store in the provided anti-tarnish pouch when not in use. Normal wear, including minor scratches or gradual plating wear over extended use, is not considered a defect and does not qualify for return.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-primary-500 mb-3">
              7. Intellectual Property
            </h2>
            <p>
              All content on this website — including text, images, logos, product designs, packaging designs, and graphics — is the property of Joviaa and protected under Indian copyright and trademark laws. You may not reproduce, distribute, modify, or use any content without our prior written consent.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-primary-500 mb-3">
              8. Limitation of Liability
            </h2>
            <p>
              Joviaa shall not be liable for any indirect, incidental, or consequential damages arising from your use of our website or products. Our total liability for any claim shall not exceed the amount paid by you for the product in question. This limitation applies to all claims regardless of the legal theory asserted.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-primary-500 mb-3">
              9. Governing Law &amp; Dispute Resolution
            </h2>
            <p>
              These Terms are governed by the laws of India. Any disputes arising out of or in connection with these Terms shall first be attempted to be resolved through amicable negotiations. If unresolved, disputes shall be subject to the exclusive jurisdiction of the courts in Mumbai, Maharashtra.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-primary-500 mb-3">
              10. Contact
            </h2>
            <p>
              For questions about these Terms, reach us at{' '}
              <a href="mailto:hello@joviaa.in" className="text-accent-500 underline">
                hello@joviaa.in
              </a>{' '}
              or WhatsApp +91 96865 43847.
            </p>
          </section>
        </div>
      </div>
    </main>
  );
}